/**
 * Truncates an address to show first and last few characters
 * @param address - The full address string
 * @param startChars - Number of characters to show at the start (default: 6)
 * @param endChars - Number of characters to show at the end (default: 4)
 * @returns Truncated address in format "123abc...xy89"
 */
export const truncateAddress = (
  address: string,
  startChars: number = 6,
  endChars: number = 4
): string => {
  if (!address) return "";
  if (address.length <= startChars + endChars) return address;

  return `${address.slice(0, startChars)}...${address.slice(-endChars)}`;
};

/**
 * Truncates an address specifically for wallet display
 * Uses consistent formatting across the app
 */
export const truncateWalletAddress = (address: string): string => {
  return truncateAddress(address, 6, 4);
};
